export interface AssetStatus {
  id: number;
  name: string | null;
}

export enum AssetStatusEnum {
  GreenTagged = 1,
  RedTagged = 2,
  YellowTagged = 3,
  Maintenance = 4,
}
